export default {"src":"/_next/static/media/BEN.384217ea.svg","height":18,"width":18};